import React, { useContext, useState } from 'react';

import { zeosDialog } from '../../../components/Shared/confirm-dialog/ConfirmDialog';
import { ZeosPasswordInput } from '../../../components/Shared/ZeosPasswordInput';
import { AuthContext } from '../../../context/AuthContext';
import { ZeosApiContext } from '../../../context/ZeosApiContext';
import { useFormValidation } from '../../../hooks/useFormValidation';
import { useSignIn } from '../../../hooks/useSignIn';
import {
    passwordValidationSchema
} from '../../../services/forms/validationSchemas/PasswordValidationSchema';
import { IZeosUserConfirmation } from '../../../services/zeos-api/contracts/Account';
import { REQUEST_ERROR } from '../../../services/zeos-api/ZeosApiExecutor';
import { OnboardContainer } from '../layout/OnboardContainer';

const defaultForm = {
  password: "",
  confirmPassword: "",
};

export const AccountPasswordScreen = () => {
  const authContext = useContext(AuthContext);
  const dataContext = useContext(ZeosApiContext);
  const [visible, setVisible] = useState(false);

  const { formData, errors, formValidate, formChange } = useFormValidation<
    typeof defaultForm
  >(passwordValidationSchema, defaultForm);

  const { signIn } = useSignIn();

  const validationCallback = async (doNavigate: () => void) => {
    const init: IZeosUserConfirmation = {
      zeosUserId: authContext.getNewZeosUser()?.zeosUserId || 0,
      password: formData.password,
      emailAddress: authContext.getNewZeosUser()?.emailAddress || "",
      accessCode: authContext.getVerificationCode(),
    };
    const setupResult = await dataContext.Account.postAccountSetupAsync(init);
    if (!setupResult.data || setupResult.zeosStatus === "error" || setupResult.message === REQUEST_ERROR || setupResult.message === "error") {
      zeosDialog("Failed to complete account setup. Please try again.");
      return;
    }
    try {
      await signIn({
        email: init.emailAddress,
        password: init.password,
        onSuccess: async (user) => {
          // confirmDialog("MESSAGE -- ACCOUNT CREATED AND LOGGED-IN SUCCESSFULLY");
        },
        onFailure: async () => {
          zeosDialog("Account created but sign-in failed. Please try signing in manually.");
        },
      });
      doNavigate();
    } catch (error) {
      console.error(error);
      zeosDialog("Account created but sign-in failed. Please try signing in manually.");
    }
  };

  const handleNext = async (doNavigate: () => void) => {
    formValidate(async () => await validationCallback(doNavigate));
  };

  const form = (
    <div className="col-span-12 sm:col-span-8 md:col-span-6 space-y-6">
      <ZeosPasswordInput
        name="password"
        label="Password"
        placeholder="Enter a password"
        value={formData.password}
        onChange={formChange("password")}
        error={errors.password}
        showRules={true}
        isVisible={visible}
        syncVisibility={true}
        toggleVisibility={() => setVisible(!visible)}
        required={true}
      />
      <ZeosPasswordInput
        name="confirmPassword"
        label="Confirm Password"
        placeholder="Re-enter password"
        value={formData.confirmPassword}
        onChange={formChange("confirmPassword")}
        error={errors.confirmPassword}
        isVisible={visible}
        syncVisibility={true}
        toggleVisibility={() => setVisible(!visible)}
        required={true}
      />
    </div>
  );

  return (
    <OnboardContainer
      content={form}
      contentType="form"
      pageSlug="account-password"
      onNext={handleNext}
    />
  );
};
